export const blockIconsBusinessandpaymentsBarChartNew = (
	<span className='material-symbols-outlined'>bar_chart</span>
);
